import React from "react"
import "./Projects.css"
import Card from "./card"
import Portfolio_data from "./Projects_data"

const Projects = () => {
  return (
    <>
      <section className='Portfolio top' id='projects'>
        <div className='container'>
          <div className='heading text-center '>
            <h4>VISIT MY PROJECTS AND KEEP YOUR FEEDBACK</h4>
            <h1>My Projects</h1>
          </div>

          <div className='content grid'>
            {Portfolio_data.map((value, index) => {
              return <Card key={index} image={value.image} category={value.category}  title={value.title} />
            })}
          </div>
        </div>
      </section>
    </>
  )
}

export default Projects